<template>
  <div>
    <v-layout row wrap align-center justify-center class="mt-5">
      <v-flex xs12 sm6 md5 lg5>
        <v-hover>
          <v-card
            class="text-xs-center ma-3"
            slot-scope="{ hover }"
            :class="`elevation-${hover ? 12 : 2}`"
          >
            <v-card-title>
            <v-layout row wrap align-center justify-center class="mt-2">
              
            <span class="headline font-weight-bold">How would we handle scale (as the product grows)</span> 
              <v-alert
                :value="true"
                color="primary"
                icon="info"
                class="caption text-lg-justify mt-3"
                outline>
                <span>Tip: If the product sells well, How would you handle scale? <br/>A few typical responses include:
                    <ul>
                        <li>
                            "I intend to use a cloud service provider such as AWS, Firebase or Azure."
                        </li>
                        <li>
                            "I intend to hire a team dedicated to handle server infrastructure."
                        </li>
                        <li>
                            "I intend to outsource all tasks concerning this matter."
                        </li>
                    </ul> </span> 
                
              </v-alert>
              <!-- <v-btn flat small :href="linktolfwireframe" target="_blank" class="mx-2 font-weight-light" align-center justify-center>Learn more about Wireframes</v-btn>  -->
              </v-layout>
            </v-card-title>
            <v-card-text>
              <v-form class="px-3" ref="form">
                <!-- <span v-for="(customerproblemdetail, index) in customerproblemdetails" :key="index"> -->
                  <!-- <v-layout row wrap>  -->

                 <v-textarea
                  outline   
                  :rules="textInputRules"
                  :label="handlingscaleLabel"
                  v-model="handlingscaledetails"
                  
                >
                 </v-textarea> 
                
                

                

                <v-spacer></v-spacer>
                <v-btn flat @click="$router.go(-1)" class="mx-4 mt-3">Head back</v-btn>
                <!-- <v-btn flat @click="submit" color="primary" class="mx-2 mt-3" :loading="loading">Add detail</v-btn> -->
                 <!-- <v-btn to="/reviewcustomerrequirements" flat color="primary" class="mx-2 mt-3" :loading="loading">Add detail</v-btn>   -->
                 <v-btn to="/addparallelinnovations" flat color="primary" class="mx-2 mt-3" :loading="loading">Go Next</v-btn>  
                
              </v-form>
            </v-card-text>
          </v-card>
        </v-hover>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import db from '../fb'
import gvars from '../globalvariables'

export default {
  name: "problemstudy",
  components: {},
  data() {
    return { 
      handlingscaledetails: 'I intend to use a cloud service provider such as AWS, Firebase or Azure.',  
      doWe: false,
      handlingscaleLabel:'How would you handle scale?',
      
            
       
      textInputRules: [
        v => !!v || 'This field is required',
        v => v.length >= 3 || 'Minimum length is 3 characters'
      ],
      selectInputRules: [
        v => !!v || 'This field is required'
      ],
      loading: false
    }
  },
  methods: {
    submit(){
 if(this.$refs.form.validate()) {
            //console.log(this.nameofthesolution, this.briefdescriptionofthesolution)
            this.loading = true;
             

            const scaledetail = {
                handlingscaledetails: this.handlingscaledetails 
            }
 

            db.collection('projects').doc(this.getProjectID()).update(scaledetail).then(() => {
                    //console.log("added to db!", docRef.id)
                    this.loading = false;
                    this.dialog = false;
                    this.$router.push('reviewcustomerrequirements')
                    ///this.$emit('firstprefdetailsconfirmed')
                });


            const metric = {
                metrictitle: this.metrictitle,
                metriccategory: 'Scale'
            }
 

            //Yx3r6dHUeFFdGvY6Acvy

           db.collection('projects').doc(this.getProjectID()).collection('metrics').add(metric).then(() => {
          //console.log("added to db!", docRef.id)
          //nameofthesolution = '';
          //briefdescriptionofthesolution = '';
          this.loading = false;
          this.dialog = false;
          //this.$emit('projectadded')
       });


            //Yx3r6dHUeFFdGvY6Acvy
 

             }

    },
    getProjectID(){
      return gvars.PROJECTID;
    }
    
  },
  computed: {
    
  }
};
</script>

<style>
</style>
